import { jsx } from "react/jsx-runtime";
import { RadioGroup, cn } from "@pcln/horizon";
import { searchFormRadioGroup } from "./SearchFormRadioGroup.variants.js";
function SearchFormRadioGroup({ className, layout = 'horizontal', wrap, ...radioGroupProps }) {
    const { root } = searchFormRadioGroup({
        wrap
    });
    return /*#__PURE__*/ jsx(RadioGroup, {
        className: cn(root(), className),
        layout: layout,
        ...radioGroupProps
    });
}
export { SearchFormRadioGroup };
